import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminStatsService } from '../services/adminStatsService';

export const SeasonContext = createContext();

export const useSeasonContext = () => {
  const context = useContext(SeasonContext);
  if (!context) {
    throw new Error('useSeasonContext must be used within a SeasonProvider');
  }
  return context;
};

export const SeasonProvider = ({ children }) => {
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [availableSeasons, setAvailableSeasons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSeasons();
  }, []);

  const loadSeasons = async () => {
    try {
      const seasons = await adminStatsService.getAllSeasons();
      setAvailableSeasons(seasons);

      if (seasons.length > 0) {
        const activeSeason = seasons.find(s => s.is_active);
        
        if (activeSeason) {
          setSelectedSeason(activeSeason);
          localStorage.setItem('selectedSeasonId', activeSeason.id);
        } else {
          const savedSeasonId = localStorage.getItem('selectedSeasonId');
          const savedSeason = seasons.find(s => s.id === Number(savedSeasonId));
          
          if (savedSeason) {
            setSelectedSeason(savedSeason);
          } else {
            setSelectedSeason(seasons[0]);
            localStorage.setItem('selectedSeasonId', seasons[0].id);
          }
        }
      }
    } catch (error) {
      console.error('Error loading seasons:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSeasonChange = (seasonId) => {
    const season = availableSeasons.find(s => s.id === Number(seasonId) || s.id === seasonId);
    if (season) {
      setSelectedSeason(season);
      localStorage.setItem('selectedSeasonId', season.id);
    }
  };

  const value = {
    selectedSeason,
    setSelectedSeason: handleSeasonChange,
    availableSeasons,
    loading,
    reloadSeasons: loadSeasons
  };

  return (
    <SeasonContext.Provider value={value}>
      {children}
    </SeasonContext.Provider>
  );
};
